// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"387":"35118d63","527":"385b4ee0","5784":"385b4ee0","7915":"952e5679","9855":"385b4ee0"}[chunkId] + ".css";
};